module.exports = __webpack_public_path__ + "static/media/timeline.ea928084.svg";